import { render, staticRenderFns } from "./GridContacts.html?vue&type=template&id=3e68e778&scoped=true&"
import script from "./GridContacts.js?vue&type=script&lang=js&"
export * from "./GridContacts.js?vue&type=script&lang=js&"
import style0 from "./GridContacts.scss?vue&type=style&index=0&id=3e68e778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e68e778",
  null
  
)

export default component.exports